import { LANDING_DYE_ATTRIBUTION_KEYS } from '@/constants/landing-dye';
import { hasLandingDyeAttribution, resolvePromotionCodeForDye } from '@/utils/landing/dye-query';

import type { ILandingDyeParams } from '@/apis/device/typings';

/**
 * 从当前 URL query 读取落地染色四要素（请求体仍用 promotion_code 字段名）。
 * 与 useLandingData 判定一致：齐全才返回，否则 null。
 */
export function pickLandingDyeParamsFromUrl(): ILandingDyeParams | null {
    if (typeof window === 'undefined') {
        return null;
    }

    const search = new URLSearchParams(window.location.search);
    if (!hasLandingDyeAttribution(search)) {
        return null;
    }

    const promotion_code = resolvePromotionCodeForDye(search);
    if (!promotion_code) {
        return null;
    }

    const result: ILandingDyeParams = {
        promotion_code,
        track_id: search.get(LANDING_DYE_ATTRIBUTION_KEYS[0]) ?? '',
        ad_id: search.get(LANDING_DYE_ATTRIBUTION_KEYS[1]) ?? '',
        adset_id: search.get(LANDING_DYE_ATTRIBUTION_KEYS[2]) ?? '',
    };

    return result;
}
